/**
 * Keeps the delivery-day quick-pick pills and the "Pick a date" date input mutually
 * exclusive, both writing into a single shared hidden input so only one value is ever
 * submitted as the cart line-item property, regardless of which the shopper used.
 */
(function () {
  function formatPickedDate(isoDate) {
    var date = new Date(isoDate + 'T00:00:00');
    if (isNaN(date.getTime())) return isoDate;
    return date.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function setup(root) {
    var valueInput = root.parentElement.querySelector('[data-delivery-day-value]');
    var options = root.querySelectorAll('[data-delivery-day-option]');
    var dateTrigger = root.querySelector('[data-delivery-day-date-trigger]');
    var dateLabel = root.querySelector('[data-delivery-day-date-label]');
    var dateInput = root.querySelector('[data-delivery-day-date-input]');
    var defaultLabel = dateLabel ? dateLabel.textContent : 'Pick a date';

    if (!valueInput) return;

    options.forEach(function (option) {
      option.addEventListener('change', function () {
        if (!option.checked) return;
        valueInput.value = option.getAttribute('data-value') || '';
        if (dateInput) dateInput.value = '';
        if (dateLabel) dateLabel.textContent = defaultLabel;
        if (dateTrigger) dateTrigger.classList.remove('is-selected');
      });
    });

    if (dateTrigger && dateInput) {
      dateTrigger.addEventListener('click', function () {
        if (typeof dateInput.showPicker === 'function') {
          try {
            dateInput.showPicker();
            return;
          } catch (e) {
            /* fall through to focus() below */
          }
        }
        dateInput.focus();
      });

      dateInput.addEventListener('change', function () {
        if (!dateInput.value) return;
        var formatted = formatPickedDate(dateInput.value);
        valueInput.value = formatted;
        if (dateLabel) dateLabel.textContent = formatted;
        dateTrigger.classList.add('is-selected');
        options.forEach(function (option) {
          option.checked = false;
        });
      });
    }
  }

  document.querySelectorAll('[data-delivery-day-picker]').forEach(setup);
})();
